import React from 'react';
import {Modal, ModalProps} from '@mui/material';
import {Close} from '@mui/icons-material';
import {Box, BoxProps} from '@mui/system';
import {SaltusAny} from '../../utils/SaltusAny';
import {themeColors} from '../../theme/Theme';

export const ScrollableModal: React.FC<
  ModalProps & {size?: 'large' | 'small' | 'xlarge' | 'medium'; autoHeight?: boolean} & {
    boxProps?: BoxProps;
    footer?: React.ReactNode;
  }
> = ({
  children,
  onClose,
  boxProps = {},
  autoHeight,
  size = 'large',
  footer,
  ...props
}) => {
  const sizeMap: Record<NonNullable<typeof size>, {width: string; height: string}> = {
    xlarge: {width: '95%', height: '95%'},
    large: {width: '40%', height: '60%'},
    medium: {width: '40%', height: '40%'},
    small: {width: '40%', height: '20%'},
  };
  const {width, height} = sizeMap[size];
  return (
    <Modal
      onBackdropClick={() => onClose?.({}, 'backdropClick')}
      {...props}
      onClose={onClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& > .MuiPaper-root': {
          background: themeColors.white,
        },
        ...(props.sx ?? ({} as SaltusAny)),
      }}
    >
      <Box
        position="relative"
        p={3}
        minWidth={size === 'small' ? undefined : 800}
        minHeight={autoHeight ? undefined : size === 'large' ? 550 : 130}
        width={width}
        height={autoHeight ? undefined : height}
        borderRadius="8px"
        bgcolor="white"
        ml="auto"
        mr="auto"
        mt="auto"
        mb="auto"
        display="flex"
        flexDirection="column"
        justifyContent="stretch"
        alignItems="stretch"
        {...boxProps}
      >
        {onClose ? (
          <Close
            style={{
              position: 'absolute',
              top: 10,
              right: 10,
              backgroundColor: 'transparent',
              zIndex: 100,
              cursor: 'pointer',
            }}
            fontSize="large"
            data-test="close-modal"
            aria-hidden={false}
            htmlColor={themeColors.coral}
            onClick={(e) => onClose?.(e as any, 'backdropClick')}
          />
        ) : null}
        <Box flex={1} sx={{overflowY: 'scroll', maxHeight: '100%'}}>
          {children}
        </Box>
        {footer}
      </Box>
    </Modal>
  );
};
